export const START_EDITING_PENDING_APPROVAL_BLURB = 'START_EDITING_BLURB'
export const STOP_EDITING_PENDING_APPROVAL_BLURB = 'STOP_EDITING_BLURB'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME = 'SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME = 'SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME = 'SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_TITLE = 'SET_PENDING_APPROVAL_BLURB_INVESTOR_TITLE'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY = 'SET_PENDING_APPROVAL_BLURB_INVESTOR_COMPANY'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY_WEBSITE = 'SET_PENDING_APPROVAL_BLURB_INVESTOR_COMPANY_WEBSITE'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS = 'SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS = 'SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB = 'SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE = 'SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_CITY = 'SET_PENDING_APPROVAL_BLURB_ADVISER_CITY'
export const SET_PENDING_APPROVAL_BLURB_ADVISER_DESCRIPTION = 'SET_PENDING_APPROVAL_BLURB_INVESTOR_DESCRIPTION'
export const CANCEL_EDITING_PENDING_APPROVAL_BLURB = 'CANCEL_EDITING_BLURB'

export const startEditingBlurb = () => ({
  type: START_EDITING_PENDING_APPROVAL_BLURB
})

export const stopEditingBlurb = (blurb) => ({
  type: STOP_EDITING_PENDING_APPROVAL_BLURB
})

export const setAdviserFirstName = (firstName) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME,
  firstName
})

export const setAdviserMiddleName = (middleName) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME,
  middleName
})

export const setAdviserLastName = (lastName) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME,
  lastName
})

export const setAdviserTitle = (title) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_TITLE,
  title
})

export const setAdviserCompany = (company) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY,
  company
})

export const setAdviserCompanyWebsite = (website) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY_WEBSITE,
  website
})

export const setAdviserBuildingDetails = (buildingDetails) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS,
  buildingDetails
})

export const setAdviserStreetAddress = (streetAddress) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS,
  streetAddress
})

export const setAdviserSuburb = (suburb) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB,
  suburb
})

export const setAdviserPostalCode = (postalCode) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE,
  postalCode
})

export const setAdviserCity = (city) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_CITY,
  city
})

export const setAdviserDescription = (adviserDescription) => ({
  type: SET_PENDING_APPROVAL_BLURB_ADVISER_DESCRIPTION,
  adviserDescription
})

export const cancelEditingAdviserProfileBlurb = () => ({
  type: CANCEL_EDITING_PENDING_APPROVAL_BLURB
})
